<template>
    <form-row title="Is this deal allowed to close early?">
        <div class="flex flex-col sm:flex-row flex-1 sm:items-center">
            <input-radio-boolean
                name="can_close_early"
                v-model="can_close_early"
                true="Yes"
                false="No"
                :read_only="read_only"
            />

            <div v-if="can_close_early" class="flex-col sm:pl-10">
                <div class="pt-3 mt-4 sm:mt-0 flex items-center">
                    <span class="w-22 flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                        {{ $t('- ON -') }}
                    </span>

                    <div class="flex-none">
                        <input-date
                            name="can_close_early_date"
                            v-model="can_close_early_date"
                            :read_only="read_only"
                            @entered="dateEntered"
                        />
                    </div>
                </div>

                <div class="pt-3 mt-4 sm:mt-0 flex items-center">
                    <span class="w-22 flex-none text-sm text-gray-warm-800 sm:pl-6 pr-6">
                        {{ $t('- OR -') }}
                    </span>

                    <div class="flex-none w-16 sm:w-1/5">
                        <input-text
                            name="can_close_early_period"
                            v-model="can_close_early_period"
                            placeholder="Days"
                            :read_only="read_only"
                            @input="periodEntered"
                        />
                    </div>

                    <span class="text-sm text-gray-warm-800 leading-snug pl-4">
                        {{ $t('days after Feasibility') }}
                    </span>
                </div>
            </div>
        </div>
    </form-row>
</template>

<script>
import DateFunctions from '../../../mixins/date-functions.js';

export default {
    mixins: [
        DateFunctions,
    ],

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            can_close_early: this.commercial.can_close_early,
            can_close_early_date: this.commercial.can_close_early_date,
            can_close_early_period: this.commercial.can_close_early_period,
        }
    },

    computed: {
        can_close_early_date_from_period() {
            if (! store.state.feasibility_date) {
                return;
            }

            if (this.can_close_early_period) {
                if (this.isValidDate(store.state.feasibility_date)) {
                    return dayjs(store.state.feasibility_date.slice(0, 10))
                        .add({ day: this.can_close_early_period })
                        .format('YYYY-MM-DD')
                } else {
                    return null;
                }
            }
        },
    },

    methods: {
        dateEntered() {
            this.can_close_early_period = null;
        },
        periodEntered(value) {
            if (! value || ! store.state.feasibility_date) {
                this.can_close_early_date = null;
            }
        },
    },

    watch: {
        can_close_early_date_from_period(val) {
            if (val) {
                this.can_close_early_date = val;
            }
        },
    },
}
</script>
